// @flow
import type { ApiExecutorType } from 'types/ApiExecutorType';
import { convertFacebookPostsFromApi } from 'services/Social';


function FacebookApi(executor: ApiExecutorType) {
  return { fetchPosts, fetchTmpPosts };

  function fetchPosts() {
    return executor.get(`rs_facebook.json`)
            .then(responses => {
              return responses.data.map(resp => convertFacebookPostsFromApi(resp));
            });
  }

  function fetchTmpPosts() {
    return executor.get(`/ffr/v1/rs_facebook`)
            .then(responses => {
              return responses.data.map(resp => convertFacebookPostsFromApi(resp));
            });
  }
}

export default FacebookApi;
